import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

/**
 * Workaround for https://github.com/Azure/static-web-apps/issues/34
 *
 * Azure Static Web Apps replaces the `Authorization` header before it reaches
 * the linked Function App.  By renaming the header to `X-Authorization` here
 * (after MSAL has set it), SWA never sees it, and the proxy in
 * api/code/index.js (SWA) and server/index.js (Linux Web App) restores it as
 * `Authorization` before forwarding to APIM. Keep this interceptor until SWA is retired.
 *
 * Only applies to same-origin `/api/` requests; external calls (e.g. MS Graph)
 * are left unchanged.
 */
@Injectable()
export class XAuthorizationInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authorization = req.headers.get('Authorization');
    if (!authorization || req.url.startsWith('https://')) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        headers: req.headers
          .delete('Authorization')
          .set('X-Authorization', authorization),
      })
    );
  }
}
